<!--GeneratorFlag:[NoChange]-->
<template>
	<kaveh-excel-import :key="ver" :entity="entity" :task="import" stream-address="hub/key-value/stream-create" @close="reset" @cancel="reset" />
</template>
<script>
	import { KeyValue } from '@/modules/hub/data/key-value/create'
	import { KeyValueService } from '@/modules/hub/services'
	export default {
		data()
		{
			return {
				ver: 0
			}
		},
		computed:
		{
			entity()
			{
				return KeyValue;
			},

			service()
			{
				return new KeyValueService();
			}
		},
		methods:
		{
			async import(payload)
			{
				return await this.service.create(payload, {HSR:false, HER:false});
			},

			reset()
			{
				this.ver = this.ver + 1;
			}
		}
	}
</script>